import {memo} from "react";
import ErrorBox from "../ErrorBox";
import {playPigSound} from "@/utils/audio";

const ErrorImage = ({error}: {error: Error | null}) => {
  return (
    <div className="flex size-full flex-col items-center justify-center">
      <img
        className="aspect-auto w-[500px] cursor-pointer"
        src="/images/pig-error.png"
        onClick={() => playPigSound("random")}
      />
      <ErrorBox className="max-w-[500px]" error={error} displayTime={0} />
    </div>
  );
};

export default memo(ErrorImage);
